import styled from 'styled-components'

export const FeaturesContainer = styled.div<{
  $background?: boolean
  $padding?: string
  $borderRadius?: string
}>`
  ${({ $background, $padding, $borderRadius, theme }) =>
    $background &&
    `
    background: ${theme.colors.background.secondary};
    border-radius: ${$borderRadius || theme.borderRadius.xlarge};
    padding: ${$padding || theme.spacing.xlarge};
  `}
`

export const FeaturesGrid = styled.div<{
  $columns?: number | 'auto'
  $minColumnWidth?: string
}>`
  display: grid;
  grid-template-columns: ${({ $columns, $minColumnWidth }) =>
    $columns === 'auto'
      ? `repeat(auto-fill, minmax(${$minColumnWidth || '200px'}, 1fr))`
      : `repeat(${$columns || 2}, 1fr)`};
  gap: ${({ theme }) => theme.spacing.medium};
`

export const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.default};
  padding: ${({ theme }) => theme.spacing.default};
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  transition: all ${({ theme }) => theme.transitions.fast};

  &:hover {
    border-color: ${({ theme }) => theme.colors.border.default};
    transform: translateY(-2px);
    box-shadow: ${({ theme }) => theme.shadows.sm};
  }
`

export const FeatureIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: ${({ theme }) => theme.borderRadius.circle};
  background: ${({ theme }) => theme.colors.background.tertiary};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    color: ${({ theme }) => theme.colors.primary};
  }
`

export const FeatureText = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text.primary};
`

export const ShowMoreButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
  margin: ${({ theme }) => theme.spacing.large} auto 0;
  padding: ${({ theme }) => theme.spacing.small}
    ${({ theme }) => theme.spacing.large};
  background: transparent;
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius.round};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text.secondary};
  cursor: pointer;
  transition: all ${({ theme }) => theme.transitions.fast};

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.primary};

    svg {
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  svg {
    color: ${({ theme }) => theme.colors.text.tertiary};
    transition: color ${({ theme }) => theme.transitions.fast};
  }
`
